var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"text-no-wrap",attrs:{"headers":_vm.headers,"items":_vm.items,"height":"270px","max-height":"350px","item-key":"c_vend","single-select":""},on:{"click:row":_vm.rowSelect,"dblclick:row":_vm.itemSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }